/**
 * MOTM cart behavior:
 * - updateCart: keep Shopify cart events working.
 * - openCart: open the MOTM quick-view drawer.
 * - if the drawer is unavailable, continue directly to Shopify checkout.
 */

function init() {
  const { actions, events } = window.Shopify;

  actions.updateCart.configure({
    onSuccess: async (_target, { detail }) => {
      const itemCount = detail?.data?.itemCount;
      document.dispatchEvent(new CustomEvent(events.cartUpdate, {
        bubbles: false,
        detail: { resource: detail?.data, sourceId: 'motm-mini-cart', itemCount },
      }));
    },
  });

  actions.openCart.configure({
    async handler() {
      const miniCart = document.querySelector('motm-mini-cart');
      if (miniCart?.open) {
        await miniCart.open();
      } else {
        window.location.assign('/checkout');
      }
    },
  });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', init, { once: true });
} else {
  init();
}
